import { useMemo } from "react";
import Card, { CardHeader } from "components/card";
import Chart from "components/charts/Chart";
import { ARCHETYPE_CHART_COLORS, ARCHETYPE_KEYS, ARCHETYPES } from "lib/archetypes";

const percent = (val) => `${val}%`;

const OPTIONS = {
  plotOptions: {
    bar: { horizontal: true, borderRadius: 4, distributed: true, barHeight: "60%" },
  },
  xaxis: { max: 100, categories: ARCHETYPE_KEYS.map((key) => ARCHETYPES[key].label) },
  colors: ARCHETYPE_CHART_COLORS,
  legend: { show: false },
  dataLabels: { enabled: true, formatter: percent },
  tooltip: { y: { formatter: percent } },
};

const StrengthsMatrix = ({ strengthsMatrix }) => {
  const series = useMemo(
    () => [
      {
        name: "Strength",
        data: ARCHETYPE_KEYS.map((key) => Number(strengthsMatrix?.[key]) || 0),
      },
    ],
    [strengthsMatrix]
  );

  if (!strengthsMatrix) return null;

  return (
    <Card padding="md">
      <CardHeader
        title="Team Strengths Matrix"
        description="Average score per archetype dimension"
        className="mb-4"
      />
      <Chart
        type="bar"
        series={series}
        options={OPTIONS}
        height="lg"
        empty={series[0].data.every((score) => !score)}
        emptyText="No completed assessments yet"
      />
    </Card>
  );
};

export default StrengthsMatrix;
